import dayjs from 'dayjs';

const BOOKING_BASE = '/bookings/calendar';

enum URLKind {
    BOOKING
}

export enum Period {
    YEAR,
    MONTH,
    DAY,
    WEEK,
    RANGE,
}

export default class URLBuilder {
    private _url: string;
    private _kind: URLKind;
    private _period: Period;
    // private _date: Moment;
    private _start: dayjs.Dayjs;
    private _end: dayjs.Dayjs;

    constructor() {
        this._url = '';
        this._kind = URLKind.BOOKING
        this._period = Period.YEAR
        this._start = dayjs()
        this._end = dayjs()
    }

    buildBooking(base: string = BOOKING_BASE): URLBuilder {
        this.baseUrl = base;
        this.urlKind = URLKind.BOOKING;
        return this;
    }

    period(period: Period): URLBuilder {
        this._period = period;
        return this;
    }
/*
    date(date: Moment): URLBuilder {
        this._date = date;
        return this;
    }
*/
    addRange(start: dayjs.Dayjs, end: dayjs.Dayjs): URLBuilder {
        if (this._kind === URLKind.BOOKING && this._period === Period.RANGE ) {
            if (start.isSame(end) || start.isBefore(end)) {
                this._start = start;
                this._end = end;
            }
        }
        return this;
    }

    build(): string {
        let res = this._url;
        switch (this._period) {
            case Period.RANGE: {
                res += '/range?';
                res += 'from=';
                res += this._start.format('YYYY-MM-DD');
                res += '&';
                res += 'to=';
                res += this._end.format('YYYY-MM-DD');
                break;
            }
            default: {
                break;
            }
        }
        return res;
    }

    private set baseUrl(url: string) {
        this._url = url;
    }

    private set urlKind(kind: URLKind) {
        this._kind = kind;
    }
}